import React from "react";
import NutritionInputGroup from "./NutritionInputGroup";
import NutrientInput from "./NutrientInput";
import { useTheme } from "@mui/material";

export interface BoundNutritionInputProps {
  value: number;
  onChange: (value: number) => void;
  dirty: boolean;
  targetValue?: number;
}

export interface BoundNutrientsRenderProps {
  protein: BoundNutritionInputProps;
  carbohydrate: BoundNutritionInputProps;
  fat: BoundNutritionInputProps;
  calories: BoundNutritionInputProps;
  adormentVariant: "distribution" | "target-overflow";
}

export function BoundNutrientsRender(props: BoundNutrientsRenderProps) {
  const theme = useTheme();
  const { protein, carbohydrate, fat, calories, adormentVariant } = props;

  const fatPercent = Math.round(((fat.value * 9) / calories.value) * 100);
  const proteinPercent = Math.round(
    ((protein.value * 4) / calories.value) * 100,
  );
  const carbohydratePercent = Math.round(
    ((carbohydrate.value * 4) / calories.value) * 100,
  );

  return (
    <>
      <NutritionInputGroup label="Protein">
        <NutrientInput
          nutrient={protein}
          type="protein"
          exampleValue={0}
          adornmentProps={{
            variant: adormentVariant,
            value: protein.value,
            targetValue: protein.targetValue,
            percent: proteinPercent,
          }}
        />
      </NutritionInputGroup>

      <NutritionInputGroup label="Carbs">
        <NutrientInput
          nutrient={carbohydrate}
          type="carbohydrate"
          exampleValue={0}
          adornmentProps={{
            variant: adormentVariant,
            value: carbohydrate.value,
            targetValue: carbohydrate.targetValue,
            percent: carbohydratePercent,
          }}
        />
      </NutritionInputGroup>
      <NutritionInputGroup label="Fat">
        <NutrientInput
          nutrient={fat}
          type="fat"
          exampleValue={0}
          adornmentProps={{
            variant: adormentVariant,
            value: fat.value,
            targetValue: fat.targetValue,
            percent: fatPercent,
          }}
        />
      </NutritionInputGroup>

      <NutritionInputGroup label="Calories" sx={{ mt: theme.spacing(3) }}>
        <NutrientInput
          nutrient={calories}
          type="calories"
          exampleValue={0}
          adornmentProps={{
            variant:
              adormentVariant === "target-overflow"
                ? "target-overflow"
                : "none",
            value: calories.value,
            targetValue: calories.targetValue,
          }}
        />
      </NutritionInputGroup>
    </>
  );
}
